var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeVuejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3H5.5L12 15L18.5 3H22L12 21L2 3ZM6.5 3H9.5L12 7.58L14.5 3H17.5L12 13.08L6.5 3Z",
    fill: "#00FF7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeVuejs);
export default __webpack_public_path__ + "static/media/icone-vuejs.17dd94e26a911b0d58153a00a433a844.svg";
export { ForwardRef as ReactComponent };